import type { ITransaction } from './transaction';

/**
 * Aggregated transaction detail returned by the Odin.Bff detail endpoint.
 * Everything the Transaction Detail page needs in a single call —
 * callback attempts are the exception and load separately (3rd party).
 */
export interface ITransactionDetail {
  transaction: ITransaction;
  relatedTransactions: ITransaction[];
  events: ITransactionEvent[];
  orderTracking: IOrderTracking | null;
  cardInfo: ICardInfo | null;
  technical: ITechnicalInfo | null;
}

export enum TransactionEventType {
  Checkout = 'checkout',
  PaymentCreated = 'payment_created',
  ThreeDs = 'three_ds',
  Authorisation = 'authorisation',
  Capture = 'capture',
  Refund = 'refund',
  Reversal = 'reversal',
  Settlement = 'settlement',
  Callback = 'callback',
  OrderStatus = 'order_status',
  Billing = 'billing',
}

export type TransactionEventOutcome = 'success' | 'failure' | 'info' | 'warning';

/** A single TX360 event. Unknown eventTypes must still render (title/description). */
export interface ITransactionEvent {
  eventType: TransactionEventType | string;
  outcome: TransactionEventOutcome;
  title: string;
  description?: string;
  timestamp: string;
  /** Small key/value facts shown under the event (ECI, auth code, AVS...) */
  data?: Record<string, string>;
}

export interface IOrderTracking {
  /** null when the merchant has the feature but no status has been set yet */
  currentStatus: string | null;
  updatedOn?: string;
  updatedBy?: string;
  /** Merchant-defined list, in the merchant's preferred order */
  availableStatuses: string[];
  /** Newest first */
  history: IOrderStatusEntry[];
}

export interface IOrderStatusEntry {
  status: string;
  timestamp: string;
  setBy: string;
}

export interface ICardInfo {
  scheme?: string;
  issuer?: string;
  issuingCountry?: string;
  /** Debit / Credit / Prepaid */
  fundingType?: string;
  /** e.g. "Visa Classic", "Mastercard World" */
  product?: string;
}

export interface ITechnicalInfo {
  ipAddress?: string;
  userAgent?: string;
  terminalId?: string;
}
